module.exports = __webpack_public_path__ + "static/scale-model-of-top-o'-hill-terrace-in-arlington-texas-df118be47a7defc99efd358fb43642d2.png";